import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Reports from './pages/Reports';
import ReportDetail from './pages/ReportDetail';
import NewReport from './pages/NewReport';
import EditReport from './pages/EditReport';
import Admin from './pages/Admin';
import AuditLog from './pages/AuditLog';
import UserSettings from './pages/UserSettings';
import AdminEmailSettings from './pages/AdminEmailSettings';
import './styles/App.css';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">Laster...</div>;
  }

  return isAuthenticated ? <Layout>{children}</Layout> : <Navigate to="/login" />;
}

function AppRoutes() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="loading">Laster...</div>;
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/reports" /> : <Login />}
      />
      <Route
        path="/"
        element={<Navigate to="/reports" />}
      />
      <Route
        path="/reports"
        element={
          <PrivateRoute>
            <Reports />
          </PrivateRoute>
        }
      />
      <Route
        path="/reports/new"
        element={
          <PrivateRoute>
            <NewReport />
          </PrivateRoute>
        }
      />
      <Route
        path="/reports/:id"
        element={
          <PrivateRoute>
            <ReportDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/reports/:id/edit"
        element={
          <PrivateRoute>
            <EditReport />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <Admin />
          </PrivateRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <PrivateRoute>
            <UserSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/email-settings"
        element={
          <PrivateRoute>
            <AdminEmailSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/audit-log"
        element={
          <PrivateRoute>
            <AuditLog />
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <Router basename="/">
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
